import { z } from 'zod';

export const LimitsSettingsSchema = z
  .object({
    faces: z
      .object({
        count: z.number().positive().optional(),
        percentage: z.number().gte(0).lte(100).optional(),
      })
      .optional(),
    textures: z
      .object({
        baseColor: z.number().gte(1).lte(16384),
        emissive: z.number().gte(1).lte(16384),
        normal: z.number().gte(1).lte(16384),
        orm: z.number().gte(1).lte(16384),
      })
      .optional(),
    megabyte: z.number().positive().optional(),
  })
  .optional();
